import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Notice } from './notice';
import NoticeItem from './notice-item';
import { FaPlus } from 'react-icons/fa';
import './styles.css';

interface NoticeListProps {
    notices: Notice[];
    handleSave: (editedNotice: Notice) => void;
    handleCancel: () => void;
    handleEdit: (noticeId: string | null) => void;
    handleCopy: (notice: Notice) => void;
    handleDelete: (noticeId: string) => void;
    expandedItemId: string | null;
    setExpandedItemId: React.Dispatch<React.SetStateAction<string | null>>;
    disabled: boolean;
    handleExpandCollapse: (noticeId: string) => void;
}

const NoticeList: React.FC<NoticeListProps> = ({ notices, handleSave, handleCancel, handleEdit, handleCopy, handleDelete, expandedItemId, setExpandedItemId, disabled }) => {
    const [editModeNoticeId, setEditModeNoticeId] = useState<string | null>(null);
    
    const handleNoticeEdit = (noticeId: string | null) => {
        setEditModeNoticeId(noticeId);
        handleEdit(noticeId);
    };

    const handleNoticeSave = (editedNotice: Notice) => {
        setEditModeNoticeId(null);
        handleSave(editedNotice);
    };

    const handleNoticeCopy = (notice: Notice) => {
        const newNotice: Notice = {
            ...notice,
            id: uuidv4(), // Generate a unique ID
            notice_name: `${notice.notice_name}`,
            start_date: new Date().toISOString().split('T')[0],
            end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        };
        handleCopy(newNotice);
        handleEdit(newNotice.id);
        setExpandedItemId(newNotice.id);
        setEditModeNoticeId(newNotice.id);
    };

    const handleNoticeDelete = (noticeId: string) => {
        handleDelete(noticeId);
    };

    const handleNoticeCancel = () => {
        setEditModeNoticeId(null);
        handleCancel();
    };

    const handleNoticeAdd = () => {
        const newNotice: Notice = {
            id: uuidv4(), // Generate a unique ID
            notice_name: 'New Notice',
            start_date: new Date().toISOString().split('T')[0],
            end_date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
            notice: '',
            isActive: true,
        };
        handleCopy(newNotice);
        handleEdit(newNotice.id);
        setExpandedItemId(newNotice.id);
        setEditModeNoticeId(newNotice.id);
    };

    return (
        <div>
            <div className="right-third list-container button-container">
                <button onClick={handleNoticeAdd} disabled={disabled || editModeNoticeId !== null}>
                    <FaPlus className="icon" />Notice
                </button>
            </div>
            {notices.map((notice) => (
                <NoticeItem
                    key={notice.id}
                    notice={notice}
                    handleNoticeEdit={handleNoticeEdit}
                    handleNoticeSave={handleNoticeSave}
                    handleNoticeCancel={handleNoticeCancel}
                    handleNoticeCopy={handleNoticeCopy}
                    handleNoticeDelete={handleNoticeDelete}
                    isEditMode={editModeNoticeId === notice.id}
                    disableEditButton={editModeNoticeId !== null}
                    expandedItemId={expandedItemId}
                    setExpandedItemId={setExpandedItemId}
                    disabled={disabled} // Pass disabled prop to NoticeItem
                />
            ))}
        </div>
    );
};

export default NoticeList;